import {FC, useEffect} from 'react'
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom'
import {
  useLazyGetSubClientCreditOverviewQuery,
  useLazyGetSubClientQuery,
} from '../../../../../services/cellcast.v2'
import {Col, Row, Spinner} from 'react-bootstrap'
import Profile from './Profile'
import InsertNewData from '../../../../Components/InsertNewData'
import DetailAction from './DetailAction'
import Overview from './Overview'
import BillingWrapper from './BillingWrapper'
import ApiWrapper from './ApiWrapper'
import SenderWrapperWrapper from './SenderWrapper'

const Detail: FC = () => {
  const {id} = useParams()
  const [fetchData, {data: user, isLoading, isFetching}] = useLazyGetSubClientQuery()
  const [
    fetchCreditOverview,
    {data: creditOverview, isLoading: creditOverViewLoading, isFetching: creditOverviewFetching},
  ] = useLazyGetSubClientCreditOverviewQuery()
  const navigate = useNavigate()
  const param = useLocation()

  useEffect(() => {
    if (id) {
      fetchData({id})
      fetchCreditOverview(id)
    }
  }, [id])

  return (
    <Routes>
      <Route
        element={
          isLoading ? (
            <div className='row flex-center h-200'>
              <Spinner />
            </div>
          ) : (
            <>
              {user && user.data ? (
                <Row>
                  <Col md={4}>
                    <Profile
                      data={user?.data}
                      reload={() => fetchData({id: id || ''})}
                      isFetching={isFetching}
                    />
                  </Col>
                  <Col md={8}>
                    <div className='d-flex justify-content-between'>
                      <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder'>
                        <li
                          className='nav-item cursor-pointer'
                          onClick={() => navigate(`/subAccount/user/${id}/overview`)}
                        >
                          <span
                            className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                              param?.pathname?.split('/').at(-1) === 'overview' && 'active'
                            } `}
                          >
                            Overview
                          </span>
                        </li>

                        <li
                          className='nav-item cursor-pointer'
                          onClick={() => navigate(`/subAccount/user/${id}/billing`)}
                        >
                          <span
                            className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                              param?.pathname?.split('/').at(-1) === 'billing' && 'active'
                            } `}
                          >
                            Billing
                          </span>
                        </li>

                        <li
                          className='nav-item cursor-pointer'
                          onClick={() => navigate(`/subAccount/user/${id}/sender`)}
                        >
                          <span
                            className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                              param?.pathname?.split('/').at(-1) === 'sender' && 'active'
                            } `}
                          >
                            Sender
                          </span>
                        </li>

                        <li
                          className='nav-item cursor-pointer'
                          onClick={() => navigate(`/subAccount/user/${id}/api`)}
                        >
                          <span
                            className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                              param?.pathname?.split('/').at(-1) === 'api' && 'active'
                            } `}
                          >
                            Api
                          </span>
                        </li>
                      </ul>
                      <div className='d-flex my-4'>
                        <DetailAction data={user?.data} reload={() => fetchData({id: id || ''})} />
                      </div>
                    </div>
                    <Outlet />
                  </Col>
                </Row>
              ) : (
                <InsertNewData
                  message={{
                    title: `Failed get data user, try reload again`,
                  }}
                  isButtonShowing={false}
                />
              )}
            </>
          )
        }
      >
        <Route index element={<Navigate to={`/subAccount/user/${id}/overview`} replace={true} />} />
        <Route
          path='/overview'
          element={
            <Overview
              isFetching={creditOverViewLoading || creditOverviewFetching}
              credit={
                creditOverview
                  ? creditOverview.data
                  : {
                      allocatedMms: 0,
                      allocatedSms: 0,
                      usedMms: 0,
                      usedSms: 0,
                      purchasedSms: 0,
                      purchasedMms: 0,
                    }
              }
            />
          }
        />
        <Route
          path='/billing'
          element={
            <BillingWrapper
              reload={() => {
                if (user && user.data._id.toString() !== user.data.ownerId.toString()) {
                  fetchData({id: id || ''})
                } else {
                  fetchCreditOverview(id || '')
                }
              }}
              data={user?.data}
              isFetching={creditOverViewLoading || creditOverviewFetching}
              credit={
                creditOverview
                  ? creditOverview.data
                  : {
                      allocatedMms: 0,
                      allocatedSms: 0,
                      usedMms: 0,
                      usedSms: 0,
                      purchasedSms: 0,
                      purchasedMms: 0,
                    }
              }
            />
          }
        />
        <Route path='/sender' element={<SenderWrapperWrapper data={user?.data} />} />
        <Route
          path='/api'
          element={
            <ApiWrapper
              reload={() => fetchCreditOverview(id || '')}
              data={user?.data}
              isFetching={creditOverViewLoading || creditOverviewFetching}
            />
          }
        />
      </Route>
    </Routes>
  )
}

export default Detail
